

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/servizionline">SERVIZI ONLINE</a></span></li>
            <li class="last"><span><a href="/sirang/gestioneprocedimentiamministrativi">Gestione Procedimenti Amministrativi (GPA)</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_js0R5d79qJC9_">
                     <span id="p_56_INSTANCE_js0R5d79qJC9"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_js0R5d79qJC9">
                           <table>
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Gestione dei Procedimenti di rilevanza Ambientale</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> Il modulo di Gestione dei Procedimenti di rilevanza Ambientale (GPA) è uno strumento che, tramite la capacità di governare i procedimenti ambientali garantisce il continuo aggiornamento del patrimonio informativo ambientale della Regione, alimentando i catasti e i moduli del SIRA con dati validati di loro interesse. La comune base di conoscenza alimentata tramite il GPA ha lo scopo di porsi come data base unico di riferimento delle imprese e degli insediamenti produttivi autorizzati, oltre che dello stato delle rispettive autorizzazioni e dei provvedimenti associati.</p>
                                       <p> Il GPA è quindi il punto principale di accesso ai procedimenti gestiti e alle informazioni riferite agli oggetti del procedimento, è lo strumento per diverse tipologie di utenti: gli operatori degli Enti, le imprese e i privati cittadini.</p>
                                       <p> Tramite gli strumenti e i servizi offerti dal GPA gli operatori dell'Ente, in funzione del proprio ruolo, possono accedere dalla propria scrivania virtuale a tutti i servizi necessari alla gestione dei procedimenti di propria competenza. Attraverso la scrivania sono in grado di seguire l'iter procedurale, richiedere modifiche e integrazioni, trasmettere modifiche ad altri enti, chiudere i procedimenti.</p>
                                       <p> Gli utenti privati e le imprese hanno, tramite il modulo, la possibilità di accedere online per inserire agevolmente i dati, con una procedura snella e intuitiva e visualizzare in maniera immediata il dato appena inserito, modificabile in ogni momento fino alla presentazione finale.</p>
                                       <p> Possono, dunque, attivare i procedimenti online, seguire l'iter amministrativo degli stessi, ricevere comunicazioni e richieste di integrazioni, ottenere l'atto finale del procedimento (autorizzazioni, certificazioni ecc.).</p>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>